import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AppRoutes from './routes/AppRoutes';
import { restoreSessionThunk } from './store/slices/auth';
import ThemeProvider from './components/common/ThemeProvider';
import './styles/index.css';
import { ToastContainer } from 'react-toastify';

function SessionRestorer({ children }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(restoreSessionThunk());
  }, [dispatch]);

  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <SessionRestorer>
          <AppRoutes />
        </SessionRestorer>

        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </BrowserRouter>
    </ThemeProvider>
  );
}
